import { createStore, combineReducers } from "redux";

import AppReducer from './AppReducer'
import ConfigFileReducer from './ConfigFileReducer'
import ListReducer from './ListReducer'

const combineReducer = combineReducers({
    app: AppReducer,
    configfile: ConfigFileReducer,
    list: ListReducer
});

let token = localStorage.getItem('USER_TOKEN');
let id = null;
let lang = 'fr_FR'

if (token != null) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    var tmp = JSON.parse(window.atob(base64));

    id = tmp['id'];
    lang = tmp['language'];
}

export const allReducer = createStore(
    combineReducer,
    {
        app: {
            token: token,
            id: id,
            lang: lang || 'en_GB',
            dns: "https://api2mt.mytravo.net",
            version: "v2",
            modal: false,
            register: false,
            login: false,
            reset: false,
            stripe: false,
            contactInfo : {}
        },
        configfile: {
            modal_export: false,
            modal_historique: false,
            modal_addToList: false,
            modal_loader: false,
            addToList: false,
            calculResult: {},
            workId: null,
            launchCalc: false,
            addToListCondition: null,
            list: null,
            article: null,
            atlError: null,
            calculError: null,
            howToLink: null,
            howToText: null,
            workTitle: null,
            workDescription: null
        },
        list:{
            list: null,
            modal_createList: false,
            article: {}
        }
    },
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js